// extracted by mini-css-extract-plugin
export default {"columns":"report-filter-layout_columns__+I87P","placeHolderShimmer":"report-filter-layout_placeHolderShimmer__LhyZ9"};